import JobApplicationByJob from './modules/job-application/components/JobApplicationByJob';
import JobApplicationTable from './modules/job-application/components/JobApplicationTable';
import JobApplicationForm from './modules/job-application/components/JobApplicationForm';
import Profile from './modules/profile/components/Profile';
import Dashboard from './modules/dashboard/components/Dashboard';
import Company from './modules/company/components/Company';
import WizardSteps from './modules/steps/components/WizardSteps';
import { Routes, Route } from 'react-router-dom';
import Guard from '../../core/guards/private.guard';
import Layout from './Layout';
import React from 'react';
import JobPreview from './modules/job/components/JobPreview';
import Job from './modules/job/components/Job';
import JobTable from './modules/job/components/JobTable';
import ClientProfile from './modules/company/components/ClientProfile';
import StageScreen from './modules/company/components/StageScreen';
import { ProfileProvider } from './modules/profile/components/ProfileContext';
import UserProfile from './modules/company/components/UserProfile';
import CandidateProfile from './modules/candidate/components/CandidateProfile';
import ChangePassword from './modules/profile/components/ChangePassword';
import CandidatesPage from './modules/candidate/components/Candidate';
import CandidateMatchPage from './modules/candidate-match/components/CandidateMatchPage';
import InterviewAgendaPage from './modules/job-application/components/InterviewAgendaPage';
import PrivateRouteFallback from './PrivateRouteFallback';
import PrivacyPolicy from '../public/components/legal/PrivacyPolicy';
import TermsAndConditions from '../public/components/legal/TermsAndConditions';
import SiteAdminGuard from '../../core/guards/site-admin.guard';
import SiteRecommendationsPage from './modules/site-recommendation/components/SiteRecommendationsPage';

const companyRoutes = [
  'company',
  'company/clients',
  'company/users',
  'company/candidates',
  'clients',
  'users',
  'company-profile',
];

const PrivateRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<Guard />}>
        <Route path="account-activation" element={<WizardSteps />} />

        <Route
          element={
            <ProfileProvider>
              <Layout />
            </ProfileProvider>
          }
        >
          <Route
            path="profile"
            element={
              <ProfileProvider>
                <Profile />
              </ProfileProvider>
            }
          />
          <Route path="profile/update-password" element={<ChangePassword />} />

          <Route path="dashboard" element={<Dashboard />} />

          <Route path="candidate-match" element={<CandidateMatchPage />} />

          <Route path="privacy" element={<PrivacyPolicy embedded />} />
          <Route path="terms" element={<TermsAndConditions embedded />} />

          <Route element={<SiteAdminGuard />}>
            <Route
              path="site-recommendations"
              element={<SiteRecommendationsPage />}
            />
          </Route>

          {companyRoutes.map((path) => (
            <Route
              key={path}
              path={path}
              element={
                <ProfileProvider>
                  <Company />
                </ProfileProvider>
              }
            />
          ))}

          <Route
            path="client-profile"
            element={
              <ProfileProvider>
                <ClientProfile />
              </ProfileProvider>
            }
          />
          <Route
            path="client-profile/:id"
            element={
              <ProfileProvider>
                <ClientProfile />
              </ProfileProvider>
            }
          />
          <Route
            path="stage-screen/:clientId"
            element={
              <ProfileProvider>
                <StageScreen />
              </ProfileProvider>
            }
          />
          <Route
            path="stage-screen/:clientId/:stageId"
            element={
              <ProfileProvider>
                <StageScreen />
              </ProfileProvider>
            }
          />
          <Route
            path="user-profile"
            element={
              <ProfileProvider>
                <UserProfile />
              </ProfileProvider>
            }
          />
          <Route
            path="user-profile/:id"
            element={
              <ProfileProvider>
                <UserProfile />
              </ProfileProvider>
            }
          />
          <Route
            path="candidate-profile"
            element={
              <ProfileProvider>
                <CandidateProfile />
              </ProfileProvider>
            }
          />
          <Route
            path="candidate-profile/:id"
            element={
              <ProfileProvider>
                <CandidateProfile />
              </ProfileProvider>
            }
          />

          <Route
            path="candidates"
            element={
              <ProfileProvider>
                <CandidatesPage />
              </ProfileProvider>
            }
          />
          <Route
            path="job"
            element={
              <ProfileProvider>
                <JobTable action={true} />
              </ProfileProvider>
            }
          />
          <Route
            path="job/create"
            element={
              <ProfileProvider>
                <Job />
              </ProfileProvider>
            }
          />
          <Route
            path="job/preview"
            element={
              <ProfileProvider>
                <JobPreview />
              </ProfileProvider>
            }
          />
          <Route
            path="job/:id"
            element={
              <ProfileProvider>
                <Job />
              </ProfileProvider>
            }
          />
          <Route
            path="job/:id/preview"
            element={
              <ProfileProvider>
                <JobPreview />
              </ProfileProvider>
            }
          />

          <Route
            path="job/:id/job-applications"
            element={
              <ProfileProvider>
                <JobApplicationByJob />
              </ProfileProvider>
            }
          />
          <Route
            path="job-applications"
            element={
              <ProfileProvider>
                <JobApplicationTable action={true} />
              </ProfileProvider>
            }
          />
          <Route
            path="job-applications/:id"
            element={
              <ProfileProvider>
                <JobApplicationForm />
              </ProfileProvider>
            }
          />

          <Route
            path="interviews/agenda"
            element={
              <ProfileProvider>
                <InterviewAgendaPage />
              </ProfileProvider>
            }
          />

          <Route path="*" element={<PrivateRouteFallback />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default PrivateRoutes;
